module.exports = __webpack_public_path__ + "img/Dantam Hair 53.7c304006.jpg";